import {useFormikContext} from 'formik';
import {useSelector} from 'react-redux';
import {filtersCompetenciesEntitiesCollectionSelector, FormNameEnum} from 'filters-selections';
import {IAddWebLinkFormBaseValues, IUploadFileFormBaseValues, IUploadScormFormBaseValues} from 'admin/resources/upload';

export const useIsCompetencySelected = () => {
  const {values} = useFormikContext<
    IUploadFileFormBaseValues | IUploadScormFormBaseValues | IAddWebLinkFormBaseValues
  >();
  const competencies = useSelector(filtersCompetenciesEntitiesCollectionSelector);
  const comptencyIds = ((values[FormNameEnum.competencies] as unknown[]) ?? [])
    .map((entry) => {
      if (entry !== null && typeof entry === 'object' && 'id' in (entry as Record<string, unknown>)) {
        return Number((entry as {id: number | string}).id);
      }
      return Number(entry);
    })
    .filter((id) => !Number.isNaN(id));

  const selectedCompetencies = competencies.filter(({id}) =>
    comptencyIds.some((selectedId) => String(selectedId) === String(id))
  );
  // Prefer form selection so hydrate works before competency lookup entities arrive.
  const hasCompetenciesSelected = comptencyIds.length > 0 || selectedCompetencies.length > 0;

  return {hasCompetenciesSelected, comptencyIds};
};
